<template>
  <div>
    <!--
    <div class="relative mx-4 my-2">
      <span v-if='debouncedApolloLoading' class="apollo-spinner text-green-500" />
      <magnify v-else :size='32' class="apollo-search left-0 " />
      <input type="search" class="w-full m-1 bg-purple-white shadow rounded border-0 p-3 pl-10" placeholder="Search images..." v-model='search' >
    </div>
    -->

    <spritesheet-gallery :images='images' :load-more='loadMore' v-on='$listeners' />

  </div>
</template>
<script>
import { uniqBy } from 'lodash';
import Magnify from '@icons/Magnify.vue';
import Loading from '@ui/atoms/Loading.vue';
import { listSpritesheetsQuery } from '@/gql/Queries.js';
import SpritesheetGallery from '@ui/molecules/SpritesheetGallery.vue';

const pageSize = 10

export default {
  inject: ['api'],
  props: {
    gameId: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      search:'',
      from: 0,
      size: 50,
      debouncedApolloLoading: false,
      getSpritesheets: {
        items: [],
        total: 0
      }
    }
  },
  apollo: {
    // Pages
    getSpritesheets: {
      fetchPolicy: 'cache-and-network',
      // GraphQL Query
      query: listSpritesheetsQuery,
      // Initial variables
      variables() {
        return {
          from: 0,
          size: this.size,
          search: this.apolloSearchString
        }
      }
    },
  },
  methods: {
    async loadMore() {
      //this.page++
      // Fetch more data and transform the original result
      const lengthBefore = this.getSpritesheets.items.length;
      try {
        const result = await this.$apollo.queries.getSpritesheets.fetchMore({
          // Transform the previous result with new data
          variables: {
            from: this.images.length,
            search: this.apolloSearchString,
            size: this.size
          },
          updateQuery: (previousResult, { fetchMoreResult }) => {
            const {getSpritesheets} = fetchMoreResult;
            const newItems = getSpritesheets.items;
            const total = getSpritesheets.total;

            const items = uniqBy([...previousResult.getSpritesheets.items, ...newItems], ({id}) => {
              return id;
            });
            return {
              getSpritesheets: {
                __typename: previousResult.getSpritesheets.__typename,
                // Merging the tag list
                items,
                total
              },
            }
          },
        })
        const currentLength = lengthBefore + result.data.getSpritesheets.items.length;
        const total = result.data.getSpritesheets.total;
        return total - currentLength;
      } catch (e) {
        console.error('error running graphql', e);
        return 0;
      }
    },
  },
  components: {
    SpritesheetGallery,
    //Magnify,
  },
  computed:{
    images() {
      return this.getSpritesheets.items.map( (img) => {
        img.url = this.api.makeSpritesheetUrlEditor(img.thumbnailImage);
        img.description = img.pack
        return img;
      });
    },
    apolloSearchString() {
      if (this.search && this.search.length) {
        return this.search;
      }
      return undefined;
    }
  },
  watch: {
    search() {
      this.from = 0;
    },
    '$apollo.loading'(nv) {
      if (!nv) {
        clearTimeout(this._debouncedApolloInterval);
        this._debouncedApolloInterval = null;
        this.debouncedApolloLoading = false;
      } else {
        clearTimeout(this._debouncedApolloInterval);
        this._debouncedApolloInterval = setTimeout( () => {
          this.debouncedApolloLoading = true;
          this._debouncedApolloInterval = null;
        }, 600);
      }
    }
  }
}
</script>
